(function(module) {
try {
  module = angular.module('betosyswebapp');
} catch (e) {
  module = angular.module('betosyswebapp', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('components/framework/framework.tpl.html',
    '<adm-framework><adm-header model="framework.headerModel"><header-nav></header-nav><adm-header-language model="framework.languageModel"></adm-header-language></adm-header><adm-sidebar></adm-sidebar><adm-content></adm-content><div ng-include="\'components/footerbar/footerbar.tpl.html\'"></div></adm-framework>');
}]);
})();



// WEBPACK FOOTER //
// ./.tmp/components/framework/framework.tpl.js